import { Box, Stack, Typography, useTheme } from '@mui/material'
import React from 'react'

import ToothIcon from '@/assets/images/fi-rs-tooth.png'
import Chip from '@/components/Chip'
import PieChart from '@/components/PieChart'
import { useBreakpoints } from '@/hooks/useBreakpoints'
import { pieChartSections } from '@/utils/constants'
import {
  allInOneRecipeChart,
  getMaskingRecipe,
} from '@/utils/matisseV2/allInOne'

type MaskingEntity = {
  recipeOutput: any
  brand: any
}

const PieChartCard = ({
  title,
  labels,
  values,
}: {
  title: string
  labels?: string[]
  values?: Array<number | string>
}) => {
  return (
    <Box
      sx={{
        flexGrow: 1,
        maxWidth: '300px',
        width: '31%',
        borderRadius: '16px',
        padding: 3,
        background: `linear-gradient(
      133.84deg,
      #4e4e4e -16.04%,
      #333333 9.33%,
      #1a1a1a 32.02%,
      #1a1a1a 62.06%,
      #262626 87.42%,
      #4e4e4e 112.12%
    )`,
        '@media (max-width: 1094px)': { minWidth: '350px' },
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        gap={1}
        mb={3}
      >
        <img src={ToothIcon} alt="error" />
        <Typography fontSize={'24px'} fontWeight={'bolder'} lineHeight={'20px'}>
          {title}
        </Typography>
      </Box>
      <Box
        flexGrow={1}
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <PieChart
          labels={labels ?? []}
          values={(values ?? []) as number[]}
          height="100px"
          width="100px"
        />
      </Box>
    </Box>
  )
}

const MaskingRecipe = ({ recipeOutput, brand }: MaskingEntity) => {
  const theme = useTheme()
  const isSingleDentin =
    recipeOutput?.provided_input?.recipe_type === 'single dentin'
  const updatedList = pieChartSections?.filter((item) =>
    isSingleDentin ? item?.key === 'middle' : item,
  )
  const { isDisplay1300 } = useBreakpoints()

  return (
    <Box
      display="flex"
      flexDirection="column"
      height="100%"
      px={4}
      sx={{ color: 'white' }}
    >
      <Stack direction="row" alignItems="center" gap={1} mb={3}>
        <Typography variant="h5">Masking:</Typography>
        {brand && (
          <Chip
            label={brand}
            sx={{
              bgcolor: theme.palette.background.chip,
              color: theme.palette.common.black,
              '&:hover': {
                bgcolor: theme.palette.background.chip,
              },
            }}
          />
        )}
      </Stack>

      <Stack
        direction="row"
        spacing={5}
        width="100%"
        sx={{
          justifyContent: 'center',
          ...(isDisplay1300
            ? { gap: '0', flexWrap: 'nowrap' }
            : { gap: '32px', flexWrap: 'wrap' }),
        }}
      >
        {updatedList?.map(({ key, label }) => {
          const chart = allInOneRecipeChart(
            getMaskingRecipe(
              recipeOutput,
              key as 'cervical' | 'middle' | 'incisal',
            ),
          )
          if (!chart.labels.length) return null
          return (
            <React.Fragment key={key}>
              <PieChartCard
                title={label}
                labels={chart.labels}
                values={chart.values}
              />
            </React.Fragment>
          )
        })}
      </Stack>
    </Box>
  )
}

export default MaskingRecipe
